export const FALLBACK_THEME = "telarya-default-light"

const themeDefinitions = {
  "telarya-default-light": {
    mode: "light",
    tokens: {
      colorPrimary: "#1890ff",
      colorInfo: "#007aff",
      colorSuccess: "#00780a",
      colorWarning: "#ffa500",
      colorError: "#e51c23",
      borderRadius: 5,
      fontSize: 12,
      colorBgBase: "#ffffff",
      colorBgContainer: "#ffffff",
      colorBgLayout: "#e6e8eb",
      colorTextBase: "#000000",
      colorText: "#000000",
      colorTextSecondary: "rgba(0, 0, 0, 0.65)",
      colorBorder: "#d9d9d9",
      colorBorderSecondary: "#eaeaea"
    },
    components: {
      Layout: {
        colorBgHeader: "#ffffff",
        colorBgBody: "#e6e8eb",
        colorBgTrigger: "#ffffff",
        colorTextLightSolid: "#1890ff"
      },
      Menu: {
        colorItemBg: "#ffffff",
        colorSubItemBg: "#ffffff",
        colorItemBgHover: "#e6e8eb",
        colorItemBgSelected: "#1890ff",
        colorItemText: "#000000",
        colorItemTextHover: "#000000",
        colorItemTextSelected: "#ffffff"
      },
      Table: {
        colorBgContainer: "#e4e2da",
        tableBg: "#e4e2da",
        tableHeaderBg: "#A3A3A3",
        tableHeaderTextColor: "#ffffff",
        tableRowHoverBg: "rgba(239, 237, 232, 0.5)",
        tableBodySortBg: "rgba(209, 203, 189, 0.5)",
        colorBorderSecondary: "#BBB",
        tableBorderColor: "#535353"
      }
    }
  },
  "telarya-default-dark": {
    mode: "dark",
    tokens: {
      colorPrimary: "#1890ff",
      colorInfo: "#a2d2fb",
      colorSuccess: "#7ce38b",
      colorWarning: "#ff8c00",
      colorError: "#ff5950",
      borderRadius: 5,
      fontSize: 12,
      colorBgBase: "#1a1a1a",
      colorBgContainer: "#242424",
      colorBgLayout: "#1a1a1a",
      colorTextBase: "#DDD",
      colorText: "#BBB",
      colorTextSecondary: "rgba(232, 232, 232, 0.65)",
      colorBorder: "#3a3a3a",
      colorBorderSecondary: "#2d2d2d"
    },
    components: {
      Layout: {
        colorBgHeader: "#1a1a1a",
        colorBgBody: "#2a2a2a",
        colorBgTrigger: "#242424",
        colorTextLightSolid: "#e8e8e8"
      },
      Menu: {
        colorItemBg: "#1a1a1a",
        colorSubItemBg: "#1a1a1a",
        colorItemBgHover: "#2d2d2d",
        colorItemBgSelected: "#1890ff",
        colorItemText: "#e8e8e8",
        colorItemTextHover: "#ffffff",
        colorItemTextSelected: "#ffffff"
      },
      Table: {
        colorBgContainer: "#2d2d2d",
        tableBg: "#2d2d2d",
        tableHeaderBg: "#1a1a1a",
        tableHeaderTextColor: "#e8e8e8",
        tableRowHoverBg: "rgba(255, 255, 255, 0.08)",
        tableBodySortBg: "rgba(255, 255, 255, 0.04)",
        colorBorderSecondary: "#3a3a3a",
        tableBorderColor: "#3a3a3a"
      }
    }
  }
}

export function getThemeDefinition(themeName) {
  return themeDefinitions[themeName] ?? themeDefinitions[FALLBACK_THEME]
}

export const availableThemes = Object.keys(themeDefinitions)
